import SectionHeading from "../../../../../../../shared/components/ui/SectionHeading/SectionHeading";

export default function BenefitsHeading({ content }) {
  const description = content.descriptionStrong ? (
    <>
      {content.description.replace(content.descriptionStrong, "")}
      <strong>{content.descriptionStrong}</strong>
    </>
  ) : (
    content.description
  );

  return (
    <div className="reveal-on-scroll reveal-on-scroll--up">
      <SectionHeading
        eyebrow={content.eyebrow}
        title={
          <>
            {content.titleMain} <br />
            <span>{content.titleAccent}</span>
          </>
        }
        description={description}
        className="benefits-section__heading"
      />
    </div>
  );
}